<template>
  <div>
    <div class="row">
      <div class="col-lg-3 col-xxl-3">
        <div class="card card-custom gutter-b" style="height: 150px">
          <div class="card-body">
            <span class="svg-icon svg-icon-3x svg-icon-primary">
              <inline-svg src="media/svg/icons/Home/Clock.svg" />
            </span>
            <div class="text-dark font-weight-bolder font-size-h2 mt-3">
              {{ customerCampaign1HourBack }}
            </div>
            <a
              href="#"
              class="text-muted text-hover-primary font-weight-bold font-size-lg mt-1"
            >
              {{
                $t(
                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.CUSTOMER_PER_HOUR"
                )
              }}
            </a>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-xxl-3">
        <div class="card card-custom gutter-b" style="height: 150px">
          <div class="card-body">
            <span class="svg-icon svg-icon-3x svg-icon-primary">
              <inline-svg src="media/svg/icons/General/Star.svg" />
            </span>
            <div class="text-dark font-weight-bolder font-size-h2 mt-3">
              {{ customerCampaignToDay }}
            </div>
            <a
              href="#"
              class="text-muted text-hover-primary font-weight-bold font-size-lg mt-1"
            >
              {{
                $t(
                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.CURRENT_CUSTOME"
                )
              }}
            </a>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-xxl-3">
        <div class="card card-custom gutter-b" style="height: 150px">
          <div class="card-body">
            <span class="svg-icon svg-icon-3x ml-n2">
              <inline-svg src="media/svg/icons/General/User.svg" />
            </span>
            <b-button
              id="popover-button-sync"
              class="float-right btn btn-default btn-circle"
            >
              <i class="fa fa-info"></i>
            </b-button>
            <b-popover target="popover-button-sync">
              จำนวนผู้ส่งใบเสร็จทั้งหมดตลอดระยะเวลากิจกรรม โดยนับจากจำนวนคน
              ไม่ได้นับจำนวนใบเสร็จที่ส่ง
            </b-popover>
            <div class="font-weight-bolder font-size-h2 mt-3">
              {{ customerCampaignAllTime }}
            </div>
            <a
              href="#"
              class="text-muted text-hover-primary font-weight-bold font-size-lg mt-1"
            >
              {{
                $t(
                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.CUSTOMER_PER_CAMPAIGN"
                )
              }}
            </a>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-xxl-3">
        <div class="card card-custom bg-primary gutter-b" style="height: 150px">
          <div class="card-body">
            <span class="svg-icon svg-icon-3x svg-icon-white ml-n2">
              <inline-svg src="media/svg/icons/General/User.svg" />
            </span>
            <b-button
              id="popover-button"
              class="float-right btn btn-default btn-circle"
            >
              <i class="fa fa-info"></i>
            </b-button>
            <b-popover target="popover-button">
              จำนวนผู้ลงทะเบียน คือ
              จำนวนคนที่กรอกหน้าลงทะเบียนเข้าร่วมกิจกรรมทั้งหมด
              ซึ่งจะประกอบด้วยคนที่ส่งใบเสร็จและไม่ส่งใบเสร็จ
            </b-popover>

            <div
              class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
            >
              {{ total_customer_register }}
            </div>
            <a
              href="#"
              class="text-inverse-primary text-hover-inverse-primary font-weight-bold font-size-lg mt-1"
            >
              {{
                $t(
                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.CAMPAIGN_CUSTOMER_REGISTER"
                )
              }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-xxl-12">
        <div class="card card-custom gutter-b p-5">
          <div class="row">
            <div class="col-lg-5 col-xxl-5">
              <label for="">
                {{
                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.FROM")
                }}
              </label>
              <date-picker v-model="from" :config="options"></date-picker>
            </div>

            <div class="col-lg-5 col-xxl-5">
              <label for="">{{
                $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.TO")
              }}</label>
              <date-picker v-model="to" :config="options"></date-picker>
            </div>

            <div class="col-lg-2 col-xxl-2 pt-8 pb-3">
              <b-button
                class="float-right"
                type="submit"
                variant="primary"
                @click.prevent="filterGraph(campaign_id)"
              >
                {{
                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.SEARCH")
                }}
              </b-button>
            </div>
          </div>

          <div class="row my-5">
            <div class="col-lg-12 col-xxl-12">
              <RegPerDayLineChart
                :data="regPerDayLineChartData"
                :key="regPerDayLineChartKey"
              />
            </div>
          </div>

          <div class="row my-5">
            <div class="col-lg-12 col-xxl-12">
              <CampaignLineChart
                :data="campaignLineChartData"
                :key="campaignLineChartKey"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-xxl-6">
              <div class="chartContainer p-5">
                <ReceiptDonutChart
                  :data="{
                    labels: this.donutChartData.receiptLable,
                    series: this.donutChartData.receiptDonutSeries,
                    colors: this.donutChartData.receiptColor
                  }"
                  :key="donutChartKey"
                />
              </div>
            </div>

            <div class="col-lg-6 col-xxl-6">
              <div class="chartContainer p-5">
                <UnapproveDonutChart
                  :data="{
                    labels: this.donutChartData.campaignReceiptUnapproveLable,
                    series: this.donutChartData
                      .campaignReceiptUnapproveDonutSeries
                  }"
                  :key="donutChartKey"
                />
              </div>
            </div>

            <div v-if="is_redeem_reward" class="col-lg-6 col-xxl-6">
              <div class="chartContainer p-5">
                <RewardDonutChart
                  :data="{
                    labels: this.donutChartData.campaignRedeemRewardLable,
                    series: this.donutChartData.campaignRedeemRewardDonutSeries
                  }"
                  :key="donutChartKey"
                />
              </div>
            </div>

          <!--   <div v-else class="col-lg-6 col-xxl-6">
              <div class="chartContainer p-5">
                <ReceiptRewardDonutChart
                  :data="{
                    labels: this.donutChartData.campaignReceiptRewardLable,
                    series: this.donutChartData.campaignReceiptRewardDonutSeries
                  }"
                  :key="donutChartKey"
                />
              </div>
            </div> -->
            <div v-else-if="template != 'funo/funo-002'" class="col-lg-6 col-xxl-6">
                      <div class="chartContainer p-5">
                        <ReceiptRewardDonutChart :data="{
                          labels: this.donutChartData.campaignReceiptRewardLable,
                          series: this.donutChartData.campaignReceiptRewardDonutSeries
                        }" :key="donutChartKey" />
                      </div>
                    </div>

            <div class="col-lg-6 col-xxl-6">
              <div class="chartContainer p-5">
                <ReceiptRewardPointDonutChart
                  :data="{
                    labels: this.donutChartData.campaignReceiptRewardPointLable,
                    series: this.donutChartData
                      .campaignReceiptRewardPointDonutSeries
                  }"
                  :key="donutChartKey"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.btn-circle {
  width: 20px;
  height: 20px;
  padding: 0px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 8px;
  line-height: 1.42857;
}
.chartContainer {
  margin: 15px 0;
  border: solid 1px #e8e8e8;
  border-radius: 0.42rem;
}
.chartContainer .apexcharts-tooltip {
  color: #111;
}
.chartContainer .apexcharts-tooltip .apexcharts-tooltip-series-group.active {
  background: #111 !important;
}
</style>

<script>
import {
  DASHBOARD_CHART_CAMPAIGN,
  DASHBOARD_CUSTOMER_LINE_CHART_CAMPAIGN,
  DASHBOARD_REG_PER_DAY_LINE_CHART_CAMPAIGN
} from "@/core/services/store/campaign.module";
import Swal from "sweetalert2";
import datePicker from "vue-bootstrap-datetimepicker";

import RegPerDayLineChart from "@/view/pages/chart/RegPerDayLineChart";
import CampaignLineChart from "@/view/pages/chart/CampaignLineChart";
import ReceiptDonutChart from "@/view/pages/chart/ReceiptDonutChart";
import UnapproveDonutChart from "@/view/pages/chart/UnapproveDonutChart";
import RewardDonutChart from "@/view/pages/chart/RewardDonutChart";
import ReceiptRewardDonutChart from "@/view/pages/chart/ReceiptRewardDonutChart";
import ReceiptRewardPointDonutChart from "@/view/pages/chart/ReceiptRewardPointDonutChart";

export default {
  name: "CampaignDashboard",
  props: ["campaign_id", "start_date", "end_date", "is_redeem_reward","template"],
  components: {
    datePicker,
    RegPerDayLineChart,
    CampaignLineChart,
    ReceiptDonutChart,
    UnapproveDonutChart,
    RewardDonutChart,
    ReceiptRewardDonutChart,
    ReceiptRewardPointDonutChart
  },
  data() {
    return {
      from: null,
      to: null,
      options: {
        useCurrent: false,
        locale: "th",
        icons: {
          time: "fas fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      customerCampaignAllTime: 0,
      customerCampaignToDay: 0,
      customerCampaign1HourBack: 0,
      total_customer_register: 0,
      regPerDayLineChartData: {
        categories: [],
        series: []
      },
      regPerDayLineChartKey: true,
      campaignLineChartData: {
        categories: [],
        series: []
      },
      campaignLineChartKey: true,
      donutChartData: {
        campaignReceiptRewardDonutSeries: [],
        campaignReceiptRewardLable: [],
        campaignReceiptRewardPointDonutSeries: [],
        campaignReceiptRewardPointLable: [],
        campaignReceiptUnapproveDonutSeries: [],
        campaignReceiptUnapproveLable: [],
        campaignRedeemRewardDonutSeries: [],
        campaignRedeemRewardLable: [],
        receiptColor: [],
        receiptDonutSeries: [],
        receiptLable: []
      },
      donutChartKey: true
    };
  },
  mounted() {
    this.from = new Date(this.start_date);
    this.to = new Date(this.end_date);
    this.fetchChartData(this.campaign_id);
    // delay for debud set datetime to datetimepicker
    setTimeout(() => {
      this.fetchRegPerDayLineChartData(this.campaign_id);
      this.fetchCustomerLineChartData(this.campaign_id);
    }, 500);
    // debug chart on resize window
    // window.addEventListener(
    //   "resize",
    //   this.debounce(() => {
    //     setTimeout(() => {
    //       this.regPerDayLineChartKey = !this.regPerDayLineChartKey;
    //       this.campaignLineChartKey = !this.campaignLineChartKey;
    //       this.donutChartKey = !this.donutChartKey;
    //     }, 1000);
    //   })
    // );
  },
  methods: {
    debounce(func) {
      var timer;
      return event => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
      };
    },
    filterGraph(campaignId) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.fetchRegPerDayLineChartData(campaignId);
          this.fetchCustomerLineChartData(campaignId);
          this.fetchChartData(campaignId);
          this.render_campaign_line_chart = false;
          this.$nextTick(() => {
            this.render_campaign_line_chart = true;
          });
          Swal.close();
        }
      });
    },
    fetchChartData(id) {
      this.$store
        .dispatch(DASHBOARD_CHART_CAMPAIGN, {
          id,
          params: { start_date: this.from, end_date: this.to }
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.customerCampaignAllTime = data.data.customerCampaignAllTime;
            this.customerCampaignToDay = data.data.customerCampaignToDay;
            this.customerCampaign1HourBack =
              data.data.customerCampaign1HourBack;
            this.total_customer_register = data.data.total_customer_register;
            this.donutChartData = data.data;
            this.donutChartKey = !this.donutChartKey;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    fetchRegPerDayLineChartData(id) {
      this.$store
        .dispatch(DASHBOARD_REG_PER_DAY_LINE_CHART_CAMPAIGN, {
          id,
          params: { start_date: this.from, end_date: this.to }
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.regPerDayLineChartData = data.data;
            this.regPerDayLineChartKey = !this.regPerDayLineChartKey;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    fetchCustomerLineChartData(id) {
      this.$store
        .dispatch(DASHBOARD_CUSTOMER_LINE_CHART_CAMPAIGN, {
          id,
          params: { start_date: this.from, end_date: this.to }
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.campaignLineChartData = data.data;
            this.campaignLineChartKey = !this.campaignLineChartKey;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    }
  }
};
</script>
